import { lensApi } from "@/services/lensApi";

export type NetworkConnectionListResponse = Dryp.ApiList<Dryp.NetworkConnection>;

export const networkConnection = {
	getAll: async (pagination: Dryp.PaginationQuery): Promise<NetworkConnectionListResponse> => {
		return lensApi.get<NetworkConnectionListResponse>(`/network-connections`, {
			params: { ...pagination },
		});
	},
	create: async (payload: Dryp.CreateNetworkConnectionRequest): Promise<void> => {
		return lensApi.post<void>(`/network-connections`, payload);
	},
	remove: async (id: Dryp.NetworkConnectionId): Promise<void> => {
		return lensApi.delete<void>(`/network-connections/${id}`);
	},
};
